// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


.vat-input-container {
  display: flex;
  padding: 5px 0;
}
.tax-prefix {
  display: flex;
  align-self: center;
  padding: 5px 10px;
  background: #f4f4f4;
  border-radius: 5px;
  margin-right: 10px;
}

.input-error {
  color: red;
  align-self: center;
  text-align: center;
  padding: 10px;
}
.payment-method-title {
  padding: 5px 0px;
  font-size: 18px;
}
.payment-method-description {
  text-transform: uppercase;
  font-size: 12px;
}
.active {
  border: 1.5px solid #007aa3 !important;
}
.plan-active-indicator {
  position: absolute;
  right: 15px;
  top: 15px;
  width: 15px;
  height: 15px;
  border: 1.5px solid #007aa3;
  border-radius: 45px;
}
.indicator-inner {
  background: #007aa3;
  width: 7px;
  height: 7px;
  border-radius: 45px;
  margin: 2.5px;
}
.checkout-plan {
  position: relative;
  padding: 20px 10px;
  border: 1.5px solid #cecece;
  border-radius: 5px;
  margin: 0 0 15px 0px;
}

.checkout-plan-name {
  text-transform: uppercase;
  font-size: 12px;
}

.checkout-plan-price {
  padding: 5px 0px;
  font-size: 18px;
}
.price-currency {
}
.price-amount {
}
.checkout-plan-description {
  font-size: 12px;
  font-weight: bold;
}

.checkout-header {
  _padding: 10px 0;
  font-size: 18px;
  font-weight: bold;
  padding: 10px;
}
.checkout-plans-header {
  font-weight: bold;
  padding: 10px 0px;
}
.checkout-note {
  font-size: 14px;
  padding: 10px;
  margin: 5px 0px;
  background: #ffffff;
  border-radius: 5px;
}
.estimate-container {
  padding: 10px;
  background: white;
  border-radius: 5px;
  margin-bottom: 10px;
}
.estimate-header {
  font-size: 12px;
  font-weight: bold;
}

.checkout-content {
  padding: 10px;
}
.checkout-footer {
  display: flex;
  justify-content: center;
}
.checkout-cart {
  display: flex;
  margin-bottom: 10px;
}
.checkout-cart > .description {
  display: flex;
}
.checkout-cart .amount {
  font-size: 20px;
  font-weight: bold;
  align-self: center;
  margin-left: 15px;
}
.checkout-cart .image {
  max-height: 80px;
}
.checkout-cart .name {
  align-self: center;
  margin-left: 10px;
  margin-top: 3px;
  margin-left: 15px;
}
.checkout-link {
  display: block;
  text-align: center;
  width: 100%;
  padding: 20px;
}

`, "",{"version":3,"sources":["webpack://./src/app/services/payment.service.ts"],"names":[],"mappings":";;;AAGA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;AACA;AACA;AACA;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;GACE,eAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf","sourcesContent":["\n\n\n.vat-input-container {\n  display: flex;\n  padding: 5px 0;\n}\n.tax-prefix {\n  display: flex;\n  align-self: center;\n  padding: 5px 10px;\n  background: #f4f4f4;\n  border-radius: 5px;\n  margin-right: 10px;\n}\n\n.input-error {\n  color: red;\n  align-self: center;\n  text-align: center;\n  padding: 10px;\n}\n.payment-method-title {\n  padding: 5px 0px;\n  font-size: 18px;\n}\n.payment-method-description {\n  text-transform: uppercase;\n  font-size: 12px;\n}\n.active {\n  border: 1.5px solid #007aa3 !important;\n}\n.plan-active-indicator {\n  position: absolute;\n  right: 15px;\n  top: 15px;\n  width: 15px;\n  height: 15px;\n  border: 1.5px solid #007aa3;\n  border-radius: 45px;\n}\n.indicator-inner {\n  background: #007aa3;\n  width: 7px;\n  height: 7px;\n  border-radius: 45px;\n  margin: 2.5px;\n}\n.checkout-plan {\n  position: relative;\n  padding: 20px 10px;\n  border: 1.5px solid #cecece;\n  border-radius: 5px;\n  margin: 0 0 15px 0px;\n}\n\n.checkout-plan-name {\n  text-transform: uppercase;\n  font-size: 12px;\n}\n\n.checkout-plan-price {\n  padding: 5px 0px;\n  font-size: 18px;\n}\n.price-currency {\n}\n.price-amount {\n}\n.checkout-plan-description {\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.checkout-header {\n  _padding: 10px 0;\n  font-size: 18px;\n  font-weight: bold;\n  padding: 10px;\n}\n.checkout-plans-header {\n  font-weight: bold;\n  padding: 10px 0px;\n}\n.checkout-note {\n  font-size: 14px;\n  padding: 10px;\n  margin: 5px 0px;\n  background: #ffffff;\n  border-radius: 5px;\n}\n.estimate-container {\n  padding: 10px;\n  background: white;\n  border-radius: 5px;\n  margin-bottom: 10px;\n}\n.estimate-header {\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.checkout-content {\n  padding: 10px;\n}\n.checkout-footer {\n  display: flex;\n  justify-content: center;\n}\n.checkout-cart {\n  display: flex;\n  margin-bottom: 10px;\n}\n.checkout-cart > .description {\n  display: flex;\n}\n.checkout-cart .amount {\n  font-size: 20px;\n  font-weight: bold;\n  align-self: center;\n  margin-left: 15px;\n}\n.checkout-cart .image {\n  max-height: 80px;\n}\n.checkout-cart .name {\n  align-self: center;\n  margin-left: 10px;\n  margin-top: 3px;\n  margin-left: 15px;\n}\n.checkout-link {\n  display: block;\n  text-align: center;\n  width: 100%;\n  padding: 20px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
